import { useState } from "react";
import { useSetPageTitle } from "../../hooks/useSetPageTitle";
import { AppLayout } from "../../components/layout/app-layout";
import GeoMapperTab from "./tabs/geo-mapper.tab";
import ScreenshotterTab from "./tabs/screenshotter.tab";


type ToolsTabs = 'geo-mapper' | 'screenshotter';


const ToolsPage = () => {
  useSetPageTitle('Tools');

  const [activeTab, setActiveTab] = useState<ToolsTabs>('geo-mapper');

  const toolTabs = [
    {
      id: 'geo-mapper',
      label: 'Geo Mapper',
      onClick: () => setActiveTab('geo-mapper'),
    },
    {
      id: 'screenshotter',
      label: 'Screenshotter',
      onClick: () => setActiveTab('screenshotter'),
    },
  ];

  return (
    <AppLayout
      activePage="/tools"
      navbarProps={{
        showBackButton: true,
        backPath: "/dashboard",
        tabs: toolTabs,
        activeTab: activeTab,
        onTabChange: (tabId: string) => setActiveTab(tabId as ToolsTabs),
      }}
    >
      <div className="h-[calc(100vh-8rem)] overflow-hidden">
        {activeTab === 'geo-mapper' && <GeoMapperTab />}
        {activeTab === 'screenshotter' && <ScreenshotterTab />}
      </div>
    </AppLayout>
  );
};

export default ToolsPage;